import { XAccordeon } from '@adornis/chemistry/elements/components/x-accordeon.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-accordeon
 */
@customElement('cr-accordeon')
export class ChromiumAccordeon extends XAccordeon {}
